import { render, staticRenderFns } from "./mailGroup.vue?vue&type=template&id=2520b406&scoped=true&"
import script from "./mailGroup.vue?vue&type=script&lang=js&"
export * from "./mailGroup.vue?vue&type=script&lang=js&"
import style0 from "./mailGroup.vue?vue&type=style&index=0&id=2520b406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520b406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2520b406')) {
      api.createRecord('2520b406', component.options)
    } else {
      api.reload('2520b406', component.options)
    }
    module.hot.accept("./mailGroup.vue?vue&type=template&id=2520b406&scoped=true&", function () {
      api.rerender('2520b406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/mailGroup.vue"
export default component.exports